/**
 * Name of the component specified in AG Grid gridOptions.statusBar.statusPanels
 */
export const ADAPTABLE_STATUS_PANEL = 'AdaptableStatusPanel';
